import CrmClient, {ICrmClient} from "@/types/clients/esquire/data/general/crm-client";
import Reservation, {IReservation} from "@/types/clients/esquire/data/general/reservation";
import _ from "lodash";
import BuildingImage, {
  BuildingImageData
} from "@/types/clients/esquire/data/general/building-image";
import FlatImage, {FlatImageData} from "@/types/clients/esquire/data/general/flat-image";
import Contract from "@/types/clients/esquire/data/general/contract";

export interface IReservationLoginData {
  routes: Record<string, string>;
  crm_client: ICrmClient,
  reservations: IReservation[],
  building_images: BuildingImageData[],
  flat_images: FlatImageData[],
  amount_of_offers: number
}

export default class ReservationLoginData {
  public routes: Record<string, string>;
  public crmClient: CrmClient;
  public reservations: Reservation[];
  public buildingImages: BuildingImage[];
  public flatImages: FlatImage[];
  public amountOfOffers: number;

  constructor(data: IReservationLoginData) {
    this.routes = data.routes as Record<string, string>;
    this.crmClient = new CrmClient(data.crm_client as ICrmClient);
    this.buildingImages = _.map(data.building_images, (imageData: BuildingImageData) => new BuildingImage(imageData));
    this.flatImages = _.map(data.flat_images, (imageData: FlatImageData) => new FlatImage(imageData));
    this.amountOfOffers = data.amount_of_offers as number;


    const buildingImageMap: Record<string, BuildingImage> = {};
    this.buildingImages.forEach((buildingImage: BuildingImage) => {
      buildingImageMap[buildingImage.buildingCode] = buildingImage;
    });

    const flatImageMap: Record<string, FlatImage> = {};
    this.flatImages.forEach((flatImage: FlatImage) => {
      flatImageMap[flatImage.flatType] = flatImage;
    });


    this.reservations = _.map(data.reservations, (reservationData: IReservation) => {
      const reservation = new Reservation(reservationData);

      if (reservation.building && buildingImageMap[reservation.building.id]) {
        reservation.building.buildingImage = buildingImageMap[reservation.building.id];
      }

      reservation.contracts = _.map(reservation.contracts, (contractData: Contract) => {
        if (flatImageMap[contractData.unitTypeId]) {
          contractData.flatImage = flatImageMap[contractData.unitTypeId];
        }

        return contractData;
      });

      return reservation;
    });
  }
}
